var map = {
	"./3Crv-logo.png": 577,
	"./BAT-logo.png": 578,
	"./BUSD-logo.png": 579,
	"./COMP-logo.png": 580,
	"./CRV-icon.png": 1468,
	"./CRV-logo.jpg": 1469,
	"./CRV-logo.png": 581,
	"./DAI-logo.png": 582,
	"./ERPH0DMWsAEWBjy.jpg": 1470,
	"./ETH-icon.png": 1471,
	"./ETH-logo.png": 583,
	"./FTM-logo.png": 584,
	"./GUSD-logo.png": 585,
	"./IEARN-icon.png": 1472,
	"./KNC-logo.png": 586,
	"./LEND-logo.png": 587,
	"./LINK-logo.png": 588,
	"./MANA-logo.png": 589,
	"./MKR-logo.png": 590,
	"./REP-logo.png": 591,
	"./SAI-logo.png": 592,
	"./SNX-logo.png": 593,
	"./SUSD-logo.png": 594,
	"./TUSD-logo.png": 364,
	"./USD-logo.png": 595,
	"./USDC-icon.png": 1473,
	"./USDC-logo.png": 596,
	"./USDT-icon.png": 1474,
	"./USDT-logo.png": 597,
	"./WETH-logo.png": 598,
	"./YFI-logo.png": 256,
	"./ZRX-logo.png": 599,
	"./aLINK-logo.png": 600,
	"./aave.png": 1475,
	"./aave.svg": 1476,
	"./alchemy.png": 1477,
	"./bzx.png": 1478,
	"./cDAIcUSDC-logo.png": 601,
	"./cUSDC-logo.png": 602,
	"./cUSDT-logo.png": 603,
	"./coinbaseWalletIcon.svg": 622,
	"./compound.png": 1479,
	"./crvBTC-logo.png": 604,
	"./crvBUSD-logo.png": 605,
	"./curvefi.jpg": 1480,
	"./ddex.jpg": 1481,
	"./ddex.png": 1482,
	"./defipulse.png": 1483,
	"./defisnap.svg": 1484,
	"./defizap.png": 1485,
	"./discord.svg": 624,
	"./dydx.jpg": 1486,
	"./dydx.svg": 1487,
	"./ethereum.png": 1488,
	"./etherscan.png": 1489,
	"./fonts/WorkSans-VariableFont_wght.ttf": 366,
	"./fortmaticIcon.png": 617,
	"./github.svg": 625,
	"./iDAI-logo.png": 606,
	"./icn-aethereum.svg": 621,
	"./icn-ledger.svg": 257,
	"./icn-metamask.svg": 365,
	"./kybernetwork.png": 1490,
	"./ledger.png": 1491,
	"./lendf.png": 1492,
	"./lendf.svg": 1493,
	"./medium.svg": 626,
	"./metamask.png": 1494,
	"./metamask.svg": 623,
	"./oCurve-logo.svg": 1495,
	"./oneinch.svg": 1496,
	"./portisIcon.png": 616,
	"./squarelink.png": 618,
	"./synthetix.png": 1497,
	"./telegram.svg": 627,
	"./torus.jpg": 620,
	"./trezor.png": 619,
	"./truffle.png": 1498,
	"./trustWallet.png": 615,
	"./twitter.svg": 628,
	"./uniswap.png": 1499,
	"./uniswap.svg": 1500,
	"./wBTC-icon.png": 1501,
	"./wBTC-logo.png": 607,
	"./walletConnectIcon.svg": 614,
	"./yCRV-logo.jpg": 1502,
	"./yCRV-logo.png": 608,
	"./ycUSDC-logo.png": 609,
	"./ycUSDT-logo.png": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1467;